export const TOGGLE_SIDEBAR = "TOGGLE_SIDEBAR";
export const TOGGLE_DARK_MODE = "TOGGLE_DARK_MODE";
export const SET_CURRENT_TAB = "SET_CURRENT_TAB";
export const SET_LOGOUT_MODAL = "SET_LOGOUT_MODAL";
